import { normalize } from 'normalizr';
import * as schema from '../schema';
import * as actionTypes from './actionTypes';
import { axiosProtected, axiosDownload, axiosPublic } from '../../axios-wizard';
import FileDownload from 'js-file-download'
import { currentLang } from './support';


const productSystemItemWithAmountToUrl = (items) => items.map((x,i) => '&product_system_items[]=' + x.id + "|" + x.amount  ).join("&");

export const downloadShortinfoPdf = (product_system_items_with_amount, product_solution_id= '') => {

    const url = '/api/print_shortinfo?' +
    'locale=' + currentLang() + productSystemItemWithAmountToUrl(product_system_items_with_amount) +
    '&product_solution_id=' + product_solution_id

    const today = new Date();
    const filename = "Hensel_Detailinformation_" + today.toISOString().slice(0, 10).trim() + '.pdf';

    return dispatch => {

        return axiosDownload.get( url )
            .then( response => {
               FileDownload(response.data, filename);
            } );
    };
};

export const downloadSolutionBimZip = (product_solution_id, product_solution_token) => {

    const url = '/api/solution_bim_export?' +
    'locale=' + currentLang() +
    '&product_solution_id=' + product_solution_id

    const filename = "Rudolf_Hensel_Brandschutzschott_" + product_solution_token + '.zip';

    return dispatch => {

        return axiosDownload.get( url )
            .then( response => {
               FileDownload(response.data, filename);
            } );
    };
};


export const downloadProductSolutionPdf = (country, fwk, installation_location, execution_type, product_system_id,
                                           product_system_items_with_amount, product_solution_id= '', hole_diameter,
                                           hole_form, hole_height, hole_width, calculation_schottbelegung_coverage,
                                           calculation_schottbelegung_status, calculation_schottbelegung_success) => {
                                            
    const url = '/api/print_solution?' +
    'country=' + country +
    '&fwk=' + fwk +
    '&installation_location=' + installation_location +
    '&execution_type=' + execution_type +
    '&product_system_id=' + product_system_id +
    '&product_solution_id=' + product_solution_id +
    '&locale=' + currentLang() + productSystemItemWithAmountToUrl(product_system_items_with_amount) +
    '&hole_diameter=' + hole_diameter +
    '&hole_form=' + hole_form +
    '&hole_height=' + hole_height +
    '&hole_width=' + hole_width +
    '&calculation_schottbelegung_coverage=' + calculation_schottbelegung_coverage +
    '&calculation_schottbelegung_status=' + calculation_schottbelegung_status +
    '&calculation_schottbelegung_success=' + calculation_schottbelegung_success

    const today = new Date();
    const filename = "Schottkonfiguration_" + today.toISOString().slice(0, 10).trim() + '.pdf';

    return dispatch => {

        return axiosDownload.get( url, {country: country})
            .then( response => {
               FileDownload(response.data, filename);
            } );
    };
};


export const downloadProductSolutionPdfFromDb = (product_solution_id, token) => {
    const url = '/api/print_solution?' +
    'locale=' + currentLang() +
    '&product_solution_id=' + product_solution_id

    const today = new Date();
    const filename = today.toLocaleDateString('de-DE').slice(0, 10).trim().replace(/\./g,"-") + '-Schottkonfiguration-' + String(token) + '.pdf';

    return dispatch => {

        return axiosDownload.get( url, {locale: currentLang()})
            .then( response => {
               FileDownload(response.data, filename);
            } );
    };
};

export const downloadIndividuellesTechnischesMerkblattPdf = (country, fwk, installation_location, execution_type, product_system_id, 
    filter_cable_penetrations, filter_cable_insulations, filter_cable_products, filter_cable_medium, filter_tube_penetrations, filter_tube_insulations, filter_tube_products, filter_tube_medium) => {

    const arrayToUrl = (name, items) => items.map((x,i) => '&' + name + '[]=' + x ).join("&");

    const url = '/api/print_individuelles_technisches_merkblatt?' + 
    'country=' + country +
    '&fwk=' + fwk +
    '&installation_location=' + installation_location +
    '&execution_type=' + execution_type +
    '&product_system_id=' + product_system_id +
    '&locale=' + currentLang() +
    arrayToUrl('filter_cable_penetrations', filter_cable_penetrations) +
    arrayToUrl('filter_cable_insulations', filter_cable_insulations) +
    arrayToUrl('filter_cable_products', filter_cable_products) +

    arrayToUrl('filter_tube_penetrations',filter_tube_penetrations) +
    arrayToUrl('filter_tube_insulations', filter_tube_insulations) +
    arrayToUrl('filter_tube_products', filter_tube_products) +
    
    '&filter_cable_medium[]=' + filter_cable_medium +
    '&filter_tube_medium[]=' + filter_tube_medium

    const filename = "Individuelles_Technisches_Merkblatt.pdf";

    return dispatch => {

        return axiosDownload.get( url )
            .then( response => {
               FileDownload(response.data, filename);
            } );
    };
}



// delete

export const deleteProductSolution = (projectId, productSolutionId) => {
    const url = '/api/product_solutions/' + productSolutionId
    return dispatch => {
        dispatch({
          type: actionTypes.DELETE_PROJECTSOLUTION_START
        });
        return axiosProtected.delete( url )
            .then( response => {
               const normalizedProjectunit = normalize(response.data, { projectunit: schema.projectunit })
               dispatch({
                 type: actionTypes.DELETE_PROJECTSOLUTION_SUCCESS,
                 values: normalizedProjectunit
               });
            } )
            .then(() => dispatch(fetchProjectOfferPositions(projectId)))
            .then(() => dispatch(calculateProjectConsumption(projectId)))
            .catch( error => {
                dispatch({
                  type: actionTypes.DELETE_PROJECTSOLUTION_FAILED
                });
            } );
    };
};


// create

export const createProductSolution = (projectunitId, wizardValues, selectedSystemItems, form_data, calcData, calculationResult) => {
    const url = '/api/product_solutions'

    const data = {product_solution: {
      product_system_id: wizardValues.productSystem,
      projectunit_id: projectunitId,
      country: wizardValues.country,
      fwk: wizardValues.fwk,
      execution_type: wizardValues.executionType,
      installation_location: wizardValues.location,
      medium_types: wizardValues.mediumTypes,
      product_solution_items_attributes: selectedSystemItems.map(x => ({ product_system_item_id: x.id,
                                                             amount: x.amount })
                                                           ),
      description: form_data['description'],
      hole_form: calcData['hole_form'],
      hole_width: calcData['hole_width'],
      hole_height: calcData['hole_height'],
      hole_diameter: calcData['hole_diameter'],
      calculation_schottbelegung_success: calculationResult.calculationSchottbelegungSuccess,
      calculation_schottbelegung_coverage: calculationResult.calculationCoverage,
      calculation_schottbelegung_status: calculationResult.calculationStatus
    }}

    return dispatch => {
        dispatch( createProductSolutionStart() );
        return axiosProtected.post( url, data )
            .then( response => {
               const normalizedProject = normalize(response.data, { projects: schema.arrayOfProjects })
               dispatch(createProductSolutionSuccess(normalizedProject));
            } )
            .catch( error => {
                dispatch(createProductSolutionFailed());
            } );
    };
};


export const createProductSolutionStart = (  ) => {
    return {
        type: actionTypes.CREATE_PRODUCTSOLUTION_START
    };
};

const createProductSolutionSuccess = ( projectunit ) => {
    return {
        type: actionTypes.CREATE_PRODUCTSOLUTION_SUCCESS,
        values: projectunit
    };
};

const createProductSolutionFailed = () => {
    return {
        type: actionTypes.CREATE_PRODUCTSOLUTION_FAILED
    };
};


export const updateProjectSolutionMetadata = (product_solution_id, form_data) => {
  const url = '/api/product_solutions/' + product_solution_id
  return dispatch => {
      dispatch( updateProductSolutionStart() );
      return axiosProtected.put( url, {product_solution: {id: product_solution_id,
                                                          description: form_data['description'],
                                                          notice: form_data['notice'] }} )
          .then( response => {
             const normalizedProductSolution = normalize(response.data, { product_solution: schema.productSolution })
             dispatch(updateProductSolutionSuccess(normalizedProductSolution));
          } )
          .catch( error => {
              dispatch(updateProductSolutionFailed());
          } );
  };
};



// update


export const updateProductSolution = (project_id, product_solution_id, selectedSystemItems, calcData, calculationResult) => {
    const url = '/api/product_solutions/' + product_solution_id
    return dispatch => {
        dispatch( updateProductSolutionStart() );
    
        return axiosProtected.put( url, { product_solution: {
          hole_form: calcData['hole_form'],
          hole_width: calcData['hole_width'],
          hole_height: calcData['hole_height'],
          hole_diameter: calcData['hole_diameter'],
          calculation_schottbelegung_success: calculationResult.calculationSchottbelegungSuccess,
          calculation_schottbelegung_coverage: calculationResult.calculationCoverage,
          calculation_schottbelegung_status: calculationResult.calculationStatus,
          product_solution_items_attributes: selectedSystemItems.map(x => ({
                                                                 product_solution_id: product_solution_id,
                                                                 product_system_item_id: x.id,
                                                                 amount: x.amount })
                                                               ),
          id: product_solution_id}} )
            .then( response => {
               const normalizedProductSolution = normalize(response.data, { product_solution: schema.productSolution })
               dispatch(updateProductSolutionSuccess(normalizedProductSolution));
            } )
            .then(() => dispatch(fetchProjectOfferPositions(project_id)))
            .then(() => dispatch(calculateProjectConsumption(project_id)))
            .catch( error => {
                dispatch(updateProductSolutionFailed());
            } );
    };
};

export const updateProductSolutionStart = (  ) => {
    return {
        type: actionTypes.UPDATE_PRODUCTSOLUTION_START
    };
};

const updateProductSolutionSuccess = ( productSolution ) => {
    return {
        type: actionTypes.UPDATE_PRODUCTSOLUTION_SUCCESS,
        values: productSolution
    };
};

const updateProductSolutionFailed = () => {
    return {
        type: actionTypes.UPDATE_PRODUCTSOLUTION_FAILED
    };
};


// update


export const calculateProductSolutionConsumption = (selectedSystemItems, calcData, calculationResult) => {
    const url = '/api/calculate_product_solution_consumption/'
    return dispatch => {
        dispatch( calculateProductSolutionConsumptionStart() );
    
        return axiosPublic.put( url, { product_solution: {
          hole_form: calcData['hole_form'],
          hole_width: calcData['hole_width'],
          hole_height: calcData['hole_height'],
          hole_diameter: calcData['hole_diameter'],
          calculation_schottbelegung_success: calculationResult.calculationSchottbelegungSuccess,
          calculation_schottbelegung_coverage: calculationResult.calculationCoverage,
          calculation_schottbelegung_status: calculationResult.calculationStatus,
          product_solution_items_attributes: selectedSystemItems.map(x => ({
                                                                 product_system_item_id: x.id,
                                                                 amount: x.amount })
                                                               )}} )
            .then( response => {
               dispatch(calculateProductSolutionConsumptionSuccess(response.data));
               return response.data;
            } );
    };
};

export const calculateProductSolutionConsumptionStart = (  ) => {
    return {
        type: actionTypes.CALCULATE_PRODUCTSOLUTION_CONSUMPTION_START
    };
};

export const calculateProductSolutionConsumptionSuccess = (consumptionData) => {
    return {
        type: actionTypes.CALCULATE_PRODUCTSOLUTION_CONSUMPTION_SUCCESS,
        consumptionData: consumptionData
    };
};











export const fetchProjectOfferPositions = (project_id) => {
    const url = '/api/project_offer_positions/' + project_id
    return dispatch => {
        dispatch(fetchProjectOfferPositionsStart());

        return axiosProtected.get(url)
            .then(response => {
                // Direkt die Daten ohne Normalisierung verwenden
                const positions = {
                    entities: {
                        project_offer_positions: response.data.project_offer_positions.reduce((acc, pos) => {
                            acc[pos.id] = pos;
                            return acc;
                        }, {})
                    },
                    result: response.data.project_offer_positions.map(pos => pos.id)
                };
                
                dispatch(fetchProjectOfferPositionsSuccess(positions.entities.project_offer_positions, positions.result, project_id));
            })
            .then(() => dispatch(calculateProjectConsumption(project_id)))
            .catch(error => {
                dispatch(fetchProjectOfferPositionsFailed());
            });
    };
};

export const fetchProjectOfferPositionsStart = (  ) => {
    return {
        type: actionTypes.FETCH_PROJECT_OFFER_POSITIONS_START
    };
};

export const fetchProjectOfferPositionsSuccess = ( projectOfferPositions, project_offer_positions_ids, project_id ) => {
    return {
        type: actionTypes.FETCH_PROJECT_OFFER_POSITIONS_SUCCESS,
        project_offer_positions: projectOfferPositions,
        project_offer_positions_ids: project_offer_positions_ids,
        project_id: project_id
    };
};

export const fetchProjectOfferPositionsFailed = () => {
    return {
        type: actionTypes.FETCH_PROJECT_OFFER_POSITIONS_FAILED
    };
};









// copy


export const copyProductSolution = (productSolutionId) => {
    const url = '/api/product_solutions/' + productSolutionId + '/clone'
    return dispatch => {
        dispatch({
          type: actionTypes.CLONE_PROJECTSOLUTION_START
        });
        return axiosProtected.post( url )
            .then( response => {
               const normalizedProjectunit = normalize(response.data, { projectunit: schema.projectunit })
               dispatch({
                 type: actionTypes.CLONE_PROJECTSOLUTION_SUCCESS,
                 values: normalizedProjectunit
               });
            } )
            .catch( error => {
                dispatch({
                  type: actionTypes.CLONE_PROJECTSOLUTION_FAILED
                });
            } );
    };
};





// fetch


export const fetchProductsolutions = (selectedSteps) => {
    const url = '/api/product_system_items/' +
                          '?country=' +  selectedSteps.country +
                          '&fwk=' + selectedSteps.fwk +
                          '&installation_location=' + selectedSteps.location +
                          '&execution_type=' + selectedSteps.executionType +
                          //'&medium_type=' + selectedSteps.mediumTypes +
                          '&product_system=' + selectedSteps.productSystem


    return dispatch => {
        dispatch( fetchProductsolutionsStart() );
        return axiosProtected.get( url )
            .then( response => {
               const normalized = normalize(response.data, { product_system_items: schema.arrayOfProductSystemItems })
               dispatch(fetchProductsolutionsSuccess(normalized));
               return normalized.result.product_system_items
            } )
            .catch( error => {
                dispatch(fetchProductsolutionsFailed());
            } );
    };
};

export const fetchProductsolutionsStart = (  ) => {
    return {
        type: actionTypes.FETCH_PRODUCTSOLUTION_START
    };
};

export const fetchProductsolutionsSuccess = ( projects ) => {
    return {
        type: actionTypes.FETCH_PRODUCTSOLUTION_SUCCESS,
        values: projects
    };
};

export const fetchProductsolutionsFailed = () => {
    return {
        type: actionTypes.FETCH_PRODUCTSOLUTION_FAILED
    };
};






export const calculateProjectConsumption = (project_id) => {
    const url = '/api/calculate_project_consumption/' + project_id
    return dispatch => {
        dispatch(calculateProjectConsumptionStart());

        return axiosProtected.get(url)
        .then(response => {
            // Direkt die Daten ohne Normalisierung verwenden
            const positions = {
                entities: {
                    project_consumptions: response.data.project_consumptions.reduce((acc, pos) => {
                        acc[pos.id] = pos;
                        return acc;
                    }, {})
                },
                result: response.data.project_consumptions.map(pos => pos.id)
            };
            
            dispatch(calculateProjectConsumptionSuccess(positions.entities.project_consumptions, positions.result, project_id));
        })
            .catch(error => {
                dispatch(calculateProjectConsumptionFailed());
            });
    };
};

export const calculateProjectConsumptionStart = (  ) => {
    return {
        type: actionTypes.CALCULATE_PROJECT_CONSUMPTION_START
    };
};

export const calculateProjectConsumptionSuccess = ( projectConsumptions, project_consumptions_ids, project_id ) => {
    return {
        type: actionTypes.CALCULATE_PROJECT_CONSUMPTION_SUCCESS,
        project_consumptions: projectConsumptions,
        project_consumptions_ids: project_consumptions_ids,
        project_id: project_id
    };
};

export const calculateProjectConsumptionFailed = () => {
    return {
        type: actionTypes.CALCULATE_PROJECT_CONSUMPTION_FAILED
    };
};







export const updateProductSolutionAmount = (project_id, product_solution_id, amount) => {
    const url = '/api/product_solutions/' + product_solution_id + '/update_amount';
    
    return dispatch => {
        return axiosProtected.put(url, {
            product_solution: {
                amount: amount,
                id: product_solution_id
            }
        })
        .then(response => {
            const normalizedProductSolution = normalize(response.data, { product_solution: schema.productSolution });
            dispatch(updateProductSolutionSuccess(normalizedProductSolution));
        })
        .then(() => dispatch(fetchProjectOfferPositions(project_id)))
        .then(() => dispatch(calculateProjectConsumption(project_id)))
        .catch(error => {
            dispatch(updateProductSolutionFailed());
        });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/productsolutions.js